/**
 * エリア情報
 */
export default {
  state: {
    // リストデータ
    list: null
  },
  getters: {
    /**
     * リストデータを取得
     */
    area_list (state) {
      return state.list || []
    },
    /**
     * エリアデータを取得
     *
     * @param value 条件となる連想配列（絞り込む項目のみ）
     * @returns エリアデータ
     */
    area: (state) => (where) => {
      const search = (list) => {
        for (const item of list) {
          if (Object.keys(item).filter(key => where[key] !== undefined && item[key] !== where[key]).length === 0) {
            return item
          }

          const children = item.children
          if (children === undefined || children === null || children.length === 0) {
            continue
          }

          const ret = search(children)
          if (ret !== null) {
            return ret
          }
        }

        return null
      }

      return search(state.list)
    }
  },
  actions: {
  },
  mutations: {
    /**
     * リストデータ
     */
    area_set_list (state, list) {
      state.list = list
    }
  }
}
